import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormatDatePipe } from './format-date.pipe';
import { DateFormatPipe } from './date-formate.pipe';
import { HtmlSanitizerPipe } from './html-sanitizer.pipe';
import { LanguageFormatPipe } from './laguage-formate.pipe';
import { SearchCountriesPipe } from './search-countries.pipe';
import { TranslateLocationPipe } from './translate-location.pipe';

@NgModule({
  declarations: [FormatDatePipe,DateFormatPipe, HtmlSanitizerPipe,LanguageFormatPipe, SearchCountriesPipe, TranslateLocationPipe],
  imports: [
    CommonModule
  ],
  exports: [
    FormatDatePipe,
    DateFormatPipe,
    HtmlSanitizerPipe,
    LanguageFormatPipe,
    SearchCountriesPipe,
    TranslateLocationPipe
  ]
})
export class PipeUtilModule { }
